var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 3.0625C3.25 1.5092 4.5092 0.25 6.0625 0.25H10.9375C12.4908 0.25 13.75 1.5092 13.75 3.0625V7.945C13.75 9.49833 12.4908 10.7575 10.9375 10.7575H10.75V10.9375C10.75 12.4908 9.49082 13.75 7.9375 13.75H3.0625C1.5092 13.75 0.25 12.4908 0.25 10.9375V6.0625C0.25 4.5092 1.5092 3.25 3.0625 3.25H3.25V3.0625ZM10.75 9.6325V6.0625C10.75 4.5092 9.49082 3.25 7.9375 3.25H4.375V3.0625C4.375 2.13052 5.13052 1.375 6.0625 1.375H10.9375C11.8694 1.375 12.625 2.13052 12.625 3.0625V7.945C12.625 8.87695 11.8694 9.6325 10.9375 9.6325H10.75Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.18328692881d7afd11379dcab29103fb.svg";
export { ForwardRef as ReactComponent };